import React from "react";
import GoogleChart from "../../../../../components/charts/googleChart/googleChart";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";

const LineOrTableChart = () => {
  const {
    chartData: {
      data_table: { rows = [], cols = [] },
      options
    },
    selectedFilters: { table_view }
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);
  const dispatch = useDispatch();
  const fixedColumn = { showRowNumber: false, frozenColumns: 1, ...options };
  return (
    <GoogleChart
      chartName="average_number_of_visits_per_client_chart"
      chartType={table_view ? "Table" : "LineChart"}
      width="1350px"
      height={400}
      isTableView={table_view}
      rows={rows}
      columns={cols}
      options={fixedColumn}
      enableEventListeners
      showCurrency={false}
      showAdditionTooltip={false}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default LineOrTableChart;
